import React from 'react'
import { Input } from 'reactstrap'

/**
 * 
 * @param {import('../types').FormV2FieldProps} param0 
 */
const SelectV2Field = ({
    value,
    onChange,
    onBlur,
    onFocus,
    isRequired,
    isDisabled,
    errorMessage,
    classes,
    styles,
    lang,
    aria,
    options,
    placeholder,
    id,
    name,
    valid,
    hasError
}) => {
    return (
        <Input
            type='select'
            value={value}
            onChange={e => onChange?.(e.target.value)}
            onBlur={onBlur}
            onFocus={onFocus}
            required={isRequired}
            disabled={isDisabled}
            invalid={hasError}
            valid={valid}
            {...aria || {}}
            className={`formV2-field-input-select ${classes?.field || ''}`}
            style={styles?.field}
            name={name}
            id={id}
        >
            {placeholder ? <option
                key='placeholder'
                value=''
            >
                {placeholder?.translate(lang)}
            </option> : null}
            {options?.map(opt => {
                return <option
                    key={opt.value}
                    value={opt.value}
                >
                    {opt.label?.translate(lang)}
                </option>
            })}
        </Input>
    )
}

export default SelectV2Field